import React from "react";
import { Route } from "react-router-dom";
import { EMPLOYEE_IMPORTER_PATHS } from "./EmployeeImporterMovedPaths";

export { EMPLOYEE_IMPORTER_PATHS } from "./EmployeeImporterMovedPaths";

const EmployeeImporterMovedPage = React.lazy(
  () => import("./components/EmployeeImporterMovedPage")
);

export const createEmployeeImporterMovedRoutes = (): React.ReactElement[] =>
  EMPLOYEE_IMPORTER_PATHS.map((path) => (
    <Route
      key={path}
      path={path}
      element={
        <React.Suspense fallback={null}>
          <EmployeeImporterMovedPage />
        </React.Suspense>
      }
    />
  ));
